
import { defineComponent, ref, onMounted } from 'vue'

import { ITodo, removeTodo, updateTodo } from '@/store/todoStore'

export default defineComponent({
  name: 'Todo',
  props: {
    data: {
      type: Object as () => ITodo,
      required: true
    }
  },
  setup (props, context) {
    const hasEditable = ref(false)
    const textNotSave = ref('')
    const inputTodoEdit = ref()
    const showButtons = ref(false)

    function toggleCompleted () {
      const completed = !props.data.completed
      updateTodo(props.data.key, { completed })

      // inputTextEdit.value.focus()
    }

    function toggleEditable () {
      console.log(props.data.key)
      hasEditable.value = !hasEditable.value
      textNotSave.value = JSON.parse(JSON.stringify(props.data.text))
      setTimeout(() => {
        if (inputTodoEdit.value) {
          inputTodoEdit.value.focus()
        }
      }, 150)
    }

    function editSave () {
      updateTodo(props.data.key, { text: textNotSave.value })
      editCancel()
    }

    function editCancel () {
      textNotSave.value = ''
      hasEditable.value = false
    }

    onMounted(() => {
      console.log(context)
      console.log('MOUNTED')
      console.log(props.data)
    })

    return {
      showButtons,
      editSave,
      editCancel,
      textNotSave,
      inputTodoEdit,
      hasEditable,
      removeTodo,
      toggleEditable,
      toggleCompleted
    }
  }
})
